import { Button, Guide } from '@zenterprise-inc/ui';

import IllustDownload from '@/assets/illust-icons/fill-p-download.svg';

interface Props {
  handleDownload: () => void;
}

const IndisProgramDownloadGuide = ({ handleDownload }: Props) => {
  return (
    <Guide onClick={handleDownload}>
      <Guide.ImageArea>
        <IllustDownload width={80} height={80} />
      </Guide.ImageArea>
      <Guide.ButtonArea>
        <Button.Box size="large" state="primary">
          프로그램 다운로드
        </Button.Box>
      </Guide.ButtonArea>
    </Guide>
  );
};

export default IndisProgramDownloadGuide;
